import type { App } from 'vue';
import { VueQueryPlugin, QueryClient, type VueQueryPluginOptions } from '@tanstack/vue-query';

// Create a global query client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // When a component unmounts, cancel any queries that are in-flight
      // This prevents unwanted state updates when components unmount
      gcTime: 1000 * 60 * 5, // 5 minutes
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
      // This ensures that queries are refetched when window regains focus
      refetchOnWindowFocus: true,
      // Cancel in-flight queries when unmounted
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
    mutations: {
      // Don't retry mutations
      retry: false,
      // Cancel in-flight mutations when components unmount
      gcTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

export const installVueQueryPlugin = (app: App) => {
  const options: VueQueryPluginOptions = {
    queryClient,
  };

  app.use(VueQueryPlugin, options);
};
